/**
 * Reads the payload of a JWT without verifying it.
 *
 * Used ONLY to render the UI — the role in this payload decides which nav
 * items appear, never whether a request is allowed. Every authorization
 * decision is re-made by customer-portal-api against the verified token.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const parts: string[] = token.split(".");
  if (parts.length !== 3) {
    return null;
  }

  try {
    const base64: string = parts[1].replace(/-/g, "+")
.replace(/_/g, "/");
    const padded: string = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json: string = decodeURIComponent(
      atob(padded)
        .split("")
        .map((c: string): string => `%${c.charCodeAt(0)
.toString(16)
.padStart(2, "0")}`)
        .join("")
    );

    const parsed: unknown = JSON.parse(json);
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      return null;
    }

    return parsed as Record<string, unknown>;
  } catch {
    return null;
  }
}
